<script>
  import _ from 'lodash';
  import InputCheckbox from '@/components/form-components/input-checkbox';

  export default {
    components: {
      InputCheckbox
    },
    props: {
      data: {
        type: Array,
        required: () => true
      },
      location: {
        type: Number,
        required: true
      },
      allowDeleteFolders: {
        type: Boolean,
        required: false,
        default: false
      },
      selectedFolders: {
        type: Array,
        required: false,
        default: () => []
      }
    },
    data: function() {
      return {
        folders: [],
        activeFolders: []
      }
    },
    computed: {
      localSelectedFolders() {
        return this.selectedFolders || [];
      }
    },
    mounted() {
      this.folders = this.buildFolders(this.data.filter(dt => dt.parent === null));
    },
    methods: {
      buildFolders (folders) {
        let data = [];
        const level = this.levels + 1;

        for (let i = 0, l = folders.length; i < l; i++) {
          const folder = folders[i];
          let dt = {
            ...folder
          };

          const children = this.data.filter(dt => dt.parent === folder.id);
          if (children.length > 0) {
            this.levels = _.max([level, this.levels]);
            dt.children = this.buildFolders(children);
          }

          data.push(dt);
        }

        return data;
      },
      openFolder (id) {
        this.activeFolders.push(id);
        const folder = this.data.find(f => f.id === id);
        if (folder && folder.parent) {
          this.openFolder(folder.parent);
        }
      },
      toggleActive (folder) {
        this.$emit('resetPagination');
        let { activeFolders } = this;
        if (activeFolders.includes(folder.id)) {
          activeFolders = activeFolders.filter(f => f !== folder.id);
        }
        else {
          activeFolders.push(folder.id);
        }
        
        this.activeFolders = [ ...activeFolders ];
        this.$emit('update', folder.id);
      },

      onDeleteRepositoryClick (repository) {
        this.$emit('onDeleteRepositoryClick', repository);
      },
      getAllChildrenIds (folder) {
        let childrenIds = [];
        if (folder.children && folder.children.length > 0) {
          folder.children.forEach(child => {
            childrenIds.push(child.id);
            // Recursively get children of children
            const nestedChildren = this.getAllChildrenIds(child);
            childrenIds = childrenIds.concat(nestedChildren);
          });
        }
        return childrenIds;
      },
      onCheckboxChange (folder) {
        const currentSelected = [...this.localSelectedFolders];
        const index = currentSelected.indexOf(folder.id);
        const isCurrentlyChecked = index > -1;
        
        if (isCurrentlyChecked) {
          // Uncheck parent and all children
          let updated = currentSelected.filter(id => id !== folder.id);
          const childrenIds = this.getAllChildrenIds(folder);
          updated = updated.filter(id => !childrenIds.includes(id));
          this.$emit('onUpdateSelectedFolders', updated);
        } else {
          // Check parent and all children
          const updated = [...currentSelected];
          updated.push(folder.id);
          const childrenIds = this.getAllChildrenIds(folder);
          childrenIds.forEach(childId => {
            if (!updated.includes(childId)) {
              updated.push(childId);
            }
          });
          this.$emit('onUpdateSelectedFolders', updated);
        }
      }
    },
    watch: {
      'folders': {
        handler() {
          this.openFolder(this.location);
        }
      }
      // 'selected': {
      //   handler(value) {
      //     this.$emit('update', value);
      //   }
      // },
      // 'location': {
      //   handler(value) {
      //     this.openFolder(value);
      //   }
      // }
    },
    render() {
      const { folders } = this;
      const buildChildren = (folders, index) => {
        const items = folders.map(folder => {
          let children;
          if (folder.children) {
            children = buildChildren(folder.children, index + 1);
          }

          const isActive = this.activeFolders.includes(folder.id);
          const isSelected = this.location === folder.id;
          const folderIconName = isActive ? 'folder-open' : 'folders';
          const icon = children ? <i class={`fas fa-${folderIconName}`}></i> : (<i class="fas fa-folder"></i>)

          const handleCheckboxChange = (value) => {
            this.onCheckboxChange(folder);
          };

          return (
            <li>
              <div class={`label ${children ? 'has-children' : ''} ${isActive ? 'active': ''} ${isSelected ? 'selected': ''}`} onClick={() => this.toggleActive(folder)}>
                <span class="item-cell item-cell-checkbox" onClick={(e) => e.stopPropagation()}>
                  {this.$createElement(InputCheckbox, {
                    props: {
                      value: this.localSelectedFolders.includes(folder.id),
                      id: 'folder-checkbox',
                      index: folder.id,
                      onChange: handleCheckboxChange
                    }
                  })}
                </span>
                <span class="item-cell item-cell-folder">
                  {icon}
                </span>
                <span class="item-cell item-cell-label">{folder.label}</span>
                { this.allowDeleteFolders &&   
                  <span class="item-cell item-cell-delete">
                    <i
                      class="fa fa-times"
                      role="button"
                      onClick={() => this.onDeleteRepositoryClick(folder)}
                    ></i>
                  </span>
                }
              </div>
              {children}
            </li>
          )
        })

        return (
          <ul class={`folder-wrapper folder--level-${index}`}>
            {items}
          </ul>
        );
      }

      const items = buildChildren(folders, 0);

      return (
        <div class="folder-structure">
          {items}
        </div>
      )
    }
  }
</script>

<style lang="scss">
  @import "../../styles/components/coding-queries/folder-structure";
</style>